<template>
    <div>
        <Table border :loading="loading" :columns="columns" :data="data" style="margin:20px 0">
           
            <template slot="action1" slot-scope="{ row, index }">
                <Button type="primary" icon="md-person-add" size="small" @click="inventory(row,index)"></Button>
            </template>
        </Table>
        <div style="display:flex;justify-content: flex-end;">
            
        </div>
        <div style="display: flex;justify-content: space-between;margin: 30px 0;">
            <Page :total="total" @on-change="pageChange"></Page>
            <Button type="primary" style="margin-top:15px" @click="returnPage" v-if="showreturnbtn">返回</Button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    
    data(){
        return{
            showreturnbtn:false,
            loading:false,
            columns:[
                {
                    title: "NO",
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: "参会者",
                    key: "userName",
                    align: "center",
                    minWidth:120
                },{
                    title: "查看继任者",
                    slot: "action1",
                    align: "center",
                    minWidth:120
                },
            ],
            data:[],
            modalShow:false,
            modal:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            id:''
        }
    },
    created(){},
    mounted(){
    },
    methods:{
        getData(){
            let obj={
                id:this.id,
                ...this.pageInfo
            }
            axios.post("/TalentInventory/selectParticipants", obj).then((res) => {
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        teamInfo(row,index){
            // window.open(window.location. origin + #/evalReport?id=${this.$route.query.id}&orgId=${this.highTechForm.orgId})
            // const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber}});
            const href="/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&id="+row.talentInventoryId+"&serialnumber="+row.serialnumber+'&pagename='+row.userName
            window.open(href,'_blank');
            // this.$router.push({ path: '/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27', 
            // query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber} })
        },
        inventory(row,index){
            this.$router.push({ path: '/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27', query: { pageLink: 'name2',plan:true ,id:row.talentInventoryId,serialnumber:row.serialnumber} })
        },
        personPage(){
            const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query:{id:1}});
            window.open('/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27','_blank');
        },
        deleteItem(){},
        selectUser(){
            this.$refs.selectPeopleVue.modal=true
        },
        returnPage(){
            this.$router.back()
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/SuccessionInventory.vue